var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLiveBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 123.695,
    height: 123.72,
    viewBox: "0 0 123.695 123.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1977",
    "data-name": "Ret\\xE2ngulo 1977",
    width: 123.695,
    height: 123.72,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09d785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098caf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-live-bank",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4063",
    "data-name": "Grupo 4063",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1820",
    "data-name": "Caminho 1820",
    d: "M87.94,0c.449.157.9.3,1.346.476a8.01,8.01,0,0,1,5.46,6.877,16.373,16.373,0,0,1,.089,2.05q.007,21.261,0,42.52v1.7H116.9c4.319,0,6.8,2.494,6.8,6.833v56.412c0,4.318-2.509,6.844-6.8,6.845H85.131c-4.279,0-6.8-2.542-6.808-6.855q-.011-6.161,0-12.32v-1.428H10.107c-5.93.006-8.076-1.469-10.107-6.938V6.767C.621,4.981,1.272,3.161,2.885,2.045A34.519,34.519,0,0,1,6.764,0ZM4.115,20.675V93.99c0,3.47,1.529,5,5.007,5h69.2V97.451q0-18.42.013-36.842a9.861,9.861,0,0,1,.3-2.619,6.043,6.043,0,0,1,5.755-4.352c2.076-.036,4.153-.007,6.245-.007V20.675ZM89.091,57.742H85.327c-2.244,0-2.882.63-2.882,2.864v47.836c0,2.285.652,2.923,2.967,2.923h31.159c2.391,0,3.008-.614,3.008-2.994V60.657a6.749,6.749,0,0,0-.03-1.086,1.882,1.882,0,0,0-1.713-1.772c-1.633-.107-3.277-.029-4.906-.029-.3,1.171-.559,2.223-.833,3.273a6.154,6.154,0,0,1-6.282,4.928q-4.771.02-9.541,0a6.19,6.19,0,0,1-6.369-5c-.268-1.047-.525-2.1-.808-3.229M4.127,16.373H90.7V9.151c0-3.571-1.484-5.034-5.077-5.034H9.187c-.4,0-.807-.017-1.207.014a4.047,4.047,0,0,0-3.83,3.827c-.089,2.771-.021,5.547-.021,8.415m115.4,98.985H82.555c-.442,3.333.231,4.316,3.548,4.285q14.735-.152,29.472,0c4.123.044,4.117-1.071,3.983-4.2a.207.207,0,0,0-.033-.082M93.4,57.789c.208.881.371,1.7.6,2.5a1.987,1.987,0,0,0,2.034,1.566c3.34.017,6.682.073,10.017-.052a2.712,2.712,0,0,0,1.837-1.253,10.7,10.7,0,0,0,.769-2.754Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1821",
    "data-name": "Caminho 1821",
    d: "M65.7,11.036c-2.619,0-5.229.01-7.843,0-1.51-.007-2.452-.825-2.434-2.068s.981-2.039,2.485-2.043q7.842-.016,15.684,0c1.535,0,2.419.8,2.4,2.092s-.88,2.01-2.457,2.018c-2.619.011-5.228,0-7.843,0",
    transform: "translate(10.546 1.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1822",
    "data-name": "Caminho 1822",
    d: "M11.021,8.991a2,2,0,0,1-1.964,2.035h-.1A2.064,2.064,0,0,1,6.932,9.047a2.115,2.115,0,0,1,2.029-2.12,2.065,2.065,0,0,1,2.063,2.064",
    transform: "translate(1.319 1.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1823",
    "data-name": "Caminho 1823",
    d: "M17.942,8.934a1.986,1.986,0,0,1-1.879,2.087c-.04,0-.082,0-.123,0a2.065,2.065,0,0,1-2.085-2.04,2.122,2.122,0,0,1,1.977-2.052,2.042,2.042,0,0,1,2.11,1.975v.03",
    transform: "translate(2.636 1.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1824",
    "data-name": "Caminho 1824",
    d: "M22.825,6.93a2.042,2.042,0,0,1,2.044,2.039v.037a1.994,1.994,0,0,1-1.954,2.023A2.037,2.037,0,0,1,20.8,9.077V9.038A2.082,2.082,0,0,1,22.825,6.93",
    transform: "translate(3.957 1.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1825",
    "data-name": "Caminho 1825",
    d: "M66.606,23.641c1.557,0,1.995.444,1.995,2.006V51.509c0,1.547-.458,2.023-2,2.023H31.442c-1.488,0-1.959-.488-1.959-1.987V25.684c0-1.61.429-2.041,2.034-2.041H66.606M32.467,50.555H65.636V26.613H32.467Z",
    transform: "translate(5.61 4.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1826",
    "data-name": "Caminho 1826",
    d: "M22.613,23.641c1.2,0,1.631.426,1.632,1.606v7.039c0,1.1-.445,1.583-1.533,1.587q-5.183.018-10.365,0c-1.089,0-1.535-.484-1.537-1.585V25.248c0-1.18.431-1.6,1.631-1.608H22.614m-.952,2.611H13.406v5.017h8.259Z",
    transform: "translate(2.057 4.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1827",
    "data-name": "Caminho 1827",
    d: "M22.614,34.4c1.2,0,1.629.426,1.631,1.608v7.039c0,1.1-.446,1.582-1.535,1.585q-5.183.018-10.365,0c-1.088,0-1.534-.486-1.535-1.587V36c0-1.178.432-1.6,1.632-1.607H22.614m-.966,2.61H13.4v5.038h8.244Z",
    transform: "translate(2.057 6.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1828",
    "data-name": "Caminho 1828",
    d: "M22.614,45.967c1.2,0,1.629.426,1.631,1.608v7.039c0,1.1-.446,1.582-1.535,1.585q-5.183.018-10.365,0c-1.088,0-1.534-.486-1.535-1.587V47.574c0-1.178.432-1.6,1.632-1.607H22.614m-.966,2.609H13.4v5.038h8.244Z",
    transform: "translate(2.057 8.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1829",
    "data-name": "Caminho 1829",
    d: "M27.489,41.507V25.684a6.262,6.262,0,0,0-.014-.732,1.459,1.459,0,0,0-2.9-.04,5.366,5.366,0,0,0-.018.732V57.364a5.366,5.366,0,0,0,.018.732,1.458,1.458,0,0,0,2.9-.032,6.262,6.262,0,0,0,.014-.732V41.508",
    transform: "translate(4.672 4.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1830",
    "data-name": "Caminho 1830",
    d: "M71.021,61.3a5.364,5.364,0,0,0-.732-.018h-57.5a5.364,5.364,0,0,0-.732.018,1.458,1.458,0,0,0,.032,2.9,6.262,6.262,0,0,0,.732.014H70.249a6.262,6.262,0,0,0,.732-.014,1.459,1.459,0,0,0,.04-2.9",
    transform: "translate(2.052 11.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1831",
    "data-name": "Caminho 1831",
    d: "M71.021,66.492a5.365,5.365,0,0,0-.732-.018h-57.5a5.365,5.365,0,0,0-.732.018,1.458,1.458,0,0,0,.032,2.9,6.26,6.26,0,0,0,.732.014H70.249a6.26,6.26,0,0,0,.732-.014,1.459,1.459,0,0,0,.04-2.9",
    transform: "translate(2.052 12.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1832",
    "data-name": "Caminho 1832",
    d: "M71.021,71.758a5.366,5.366,0,0,0-.732-.018h-57.5a5.366,5.366,0,0,0-.732.018,1.458,1.458,0,0,0,.032,2.9,6.259,6.259,0,0,0,.732.014H70.249a6.259,6.259,0,0,0,.732-.014,1.459,1.459,0,0,0,.04-2.9",
    transform: "translate(2.052 13.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1833",
    "data-name": "Caminho 1833",
    d: "M55.62,51.218h7.911a4.759,4.759,0,0,1,.8.044,1.434,1.434,0,0,1,.106,2.8,4.635,4.635,0,0,1-1.018.083q-7.8.007-15.6,0a4.635,4.635,0,0,1-1.018-.083,1.435,1.435,0,0,1,.1-2.8,4.76,4.76,0,0,1,.8-.044H55.62",
    transform: "translate(8.702 9.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1834",
    "data-name": "Caminho 1834",
    d: "M33.995,51.221c.976,0,1.953-.012,2.929,0a1.465,1.465,0,1,1,.333,2.911,1.438,1.438,0,0,1-.312,0q-2.928.041-5.859,0a1.466,1.466,0,0,1-.257-2.92,1.482,1.482,0,0,1,.308.006c.952-.014,1.9,0,2.857,0",
    transform: "translate(5.612 9.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1835",
    "data-name": "Caminho 1835",
    d: "M43.116,52.652a1.46,1.46,0,1,1-1.493-1.428h.031a1.449,1.449,0,0,1,1.462,1.428",
    transform: "translate(7.648 9.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1836",
    "data-name": "Caminho 1836",
    d: "M40.687,37.3c0-1.757-.007-3.514,0-5.269a1.489,1.489,0,0,1,2.4-1.378q4.535,2.6,9.054,5.225a1.508,1.508,0,0,1,0,2.838q-4.487,2.608-8.99,5.19c-1.353.776-2.457.14-2.463-1.409-.006-1.732,0-3.464,0-5.2m2.969-2.936v5.872l5.084-2.94-5.084-2.932",
    transform: "translate(7.739 5.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1837",
    "data-name": "Caminho 1837",
    d: "M28.643,79.828H44.466a6.262,6.262,0,0,0,.732-.014,1.459,1.459,0,0,0,.04-2.9,5.365,5.365,0,0,0-.732-.018H12.787a5.348,5.348,0,0,0-.731.018,1.458,1.458,0,0,0,.032,2.9,6.263,6.263,0,0,0,.732.015H28.643",
    transform: "translate(2.052 14.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1838",
    "data-name": "Caminho 1838",
    d: "M101.067,62.447c1.218,0,1.562.346,1.562,1.57V84.252c0,1.213-.357,1.582-1.563,1.582H73.554c-1.164,0-1.533-.381-1.533-1.554V64.044c0-1.26.334-1.6,1.591-1.6h27.455M74.356,83.5H100.3V64.769H74.356Z",
    transform: "translate(13.704 11.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1839",
    "data-name": "Caminho 1839",
    d: "M92.471,84.025h6.189a3.7,3.7,0,0,1,.628.035,1.122,1.122,0,0,1,.082,2.189,3.575,3.575,0,0,1-.8.065H86.369a3.575,3.575,0,0,1-.8-.065,1.122,1.122,0,0,1,.082-2.189,3.7,3.7,0,0,1,.628-.035h6.189",
    transform: "translate(16.123 15.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1840",
    "data-name": "Caminho 1840",
    d: "M75.55,84.026c.764,0,1.528-.01,2.291,0a1.147,1.147,0,0,1,.282,2.277,1.1,1.1,0,0,1-.265,0q-2.291.032-4.584,0a1.146,1.146,0,0,1-.2-2.284,1.169,1.169,0,0,1,.242,0c.745-.012,1.49,0,2.235,0",
    transform: "translate(13.705 15.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1841",
    "data-name": "Caminho 1841",
    d: "M82.688,85.145a1.142,1.142,0,1,1-1.171-1.114h.027a1.133,1.133,0,0,1,1.144,1.114",
    transform: "translate(15.298 15.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1842",
    "data-name": "Caminho 1842",
    d: "M80.787,73.139V69.016a1.165,1.165,0,0,1,1.876-1.078q3.548,2.034,7.084,4.089a1.18,1.18,0,0,1,0,2.22q-3.512,2.041-7.035,4.061c-1.059.608-1.922.109-1.927-1.1V73.139m2.322-2.3v4.594l3.978-2.3L83.108,70.84",
    transform: "translate(15.369 12.879)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLiveBank);
export default __webpack_public_path__ + "static/media/icon-live-bank.3476334f2148c25f499d165b0d2406f4.svg";
export { ForwardRef as ReactComponent };